import _ from 'lodash';
import { locale } from './../../ModuleEditor/util/locale-wrapper';

/**
 * values to be used on 'date' and 'date of birth' form field for setting 'format'
 */

const DATE_FORMATS = {
  D_M_Y: 'dmy',
  M_D_Y: 'mdy',
  D_M:   'dm',
  M_D:   'md',
  M_Y:   'my',
  Y_M:   'ym',
  Y:     'y',
};

DATE_FORMATS.ALL = _.values(DATE_FORMATS);

const DATE_FORMATS_LIST = [
  { text: locale('Day/Month/Year'), value: DATE_FORMATS.D_M_Y },
  { text: locale('Month/Day/Year'), value: DATE_FORMATS.M_D_Y },
];

const DATE_FORMATS_ALL = _.map(DATE_FORMATS_LIST, 'value');

const MONTHS_LIST = [
  { value: '1', text: 'Jan' },
  { value: '2', text: 'Feb' },
  { value: '3', text: 'Mar' },
  { value: '4', text: 'Apr' },
  { value: '5', text: 'May' },
  { value: '6', text: 'Jun' },
  { value: '7', text: 'Jul' },
  { value: '8', text: 'Aug' },
  { value: '9', text: 'Sep' },
  { value: '10', text: 'Oct' },
  { value: '11', text: 'Nov' },
  { value: '12', text: 'Dec' },
];

const MONTHS_OBJ = _.reduce(
  MONTHS_LIST,
  function (ret, month) {
    ret[month.value] = month.text;
    return ret;
  },
  {}
);

export { DATE_FORMATS, DATE_FORMATS_LIST, DATE_FORMATS_ALL, MONTHS_LIST, MONTHS_OBJ };

export default DATE_FORMATS;
